import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import type { DateFieldProps } from 'atom-components/form-fields-for-formik/date-field/date-field';
import DateField from 'atom-components/form-fields-for-formik/date-field/date-field';

type Props = {
  startProps: DateFieldProps;
  endProps: DateFieldProps;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
};

export default function DateRangeField({
  startProps,
  endProps,
  minDate,
  maxDate,
  className
}: Props): ReactElement {
  const { values } = useFormikContext();

  const startValue = get(values, startProps.name);
  const endValue = get(values, endProps.name);
  const startDate = startValue ? new Date(startValue) : undefined;
  const endDate = endValue ? new Date(endValue) : undefined;

  return (
    <>
      <DateField
        {...startProps}
        className={clsx(className, startProps.className)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
        containerZIndex={99} // Ensure that this number is higher than that of the bottom date picker so that the dropdown part won't appear under it.
      />
      <DateField
        {...endProps}
        className={clsx(className, endProps.className)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        maxDate={maxDate}
        containerZIndex={98} // Ensure that this number is lower than that of the top date picker.
      />
    </>
  );
}
